import React from "react";
import { tokens } from "../../../../public/tokens";
import { StyledPillLabel } from "./labels.styles";

const { colors } = tokens;

/**
 * Closest tokens.js hues to the legacy `RenderModuleStatus` pills (utils/CommonGroupingItem.js).
 * Approved and Inactive have no close token, so they keep the legacy hex as-is.
 */
const MODULE_STATUS_COLORS = {
    Draft: { bg: colors.states.alert["100"], fg: colors.states.alert.default },
    New: { bg: colors.states.info["100"], fg: colors.states.info.default },
    Final: { bg: colors.states.success["100"], fg: colors.states.success.default },
    Approved: { bg: "#e7e8d7", fg: "#abb072" },
    Inactive: { bg: "#e0edff", fg: "#1899d2" },
};

/**
 * Module status pill (e.g. "DRAFT"), matching the module table's Type filter look.
 * @param {string} props.value `module_status` value; unknown values render as plain uppercase text.
 */
function ModuleStatusLabel({ value }) {
    const statusColors = MODULE_STATUS_COLORS[value] || {};
    return (
        <StyledPillLabel $bg={statusColors.bg} $fg={statusColors.fg} title={value}>
            {value}
        </StyledPillLabel>
    );
}

ModuleStatusLabel.displayName = "ModuleStatusLabel";

export default ModuleStatusLabel;
